<div class="mb-neg-40">
  <h3 class="my-5" translate>billing_tab_autotopup</h3>
  <form class="mb-5" *ngIf="autotopupForm" [formGroup]="autotopupForm">
    <div>
      <div>
        <div class="page__form-wrap">
          <div class="form-group row">
            <mat-slide-toggle
              (change)="enableAutoTopUp($event)"
              aria-label="Slide me!"
              class="alert-credit__toggle"
              data-label-on="On"
              data-label-off="Off"
              formControlName="enabled"
            >
            </mat-slide-toggle>
          </div>
          <div class="form-group row">
            <label for="alertLimit" class="col-sm-4 align-self-start" translate>billing_autotopup_threeshold_label</label>
            <div class="col-sm-6" translate>
              <input type="number" class="form-control" id="alertLimit" formControlName="alertLimit" />
              <small class="form-text text-muted" translate>billing_autotopup_alertlimit_help</small>
              <wsb-validation-error-msg [fc]="autotopupForm.get('alertLimit')"></wsb-validation-error-msg>
            </div>
            <div class="col-sm-2">
              <span translate>common_currency</span>
            </div>
          </div>
          <div class="form-group row">
            <label for="alertLimit" class="col-sm-4 align-self-start" translate>billing_autotopup_shopitems_select_label</label>
            <div class="col-sm-8" translate>
              <ng-select
                [items]="shopItemSMS"
                [clearable]="false"
                clearAllText
                bindLabel="itemSelected.label"
                class="form-control"
                [(ngModel)]="itemSelected"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="selectItem($event)"
              >
                <ng-template ng-option-tmp let-item="item">
                  <span>{{ replaceLabelTagWithValue(item) }}</span>
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                  <span>{{ replaceLabelTagWithValue(item) }}</span>
                </ng-template>
              </ng-select>
              <small class="form-text text-muted" translate>billing_autotopup_package_help</small>
              <wsb-validation-error-msg [fc]="autotopupForm.get('idShopItem')"></wsb-validation-error-msg>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm-4 d-flex align-items-center">
              <label for="alertLimitCheck" translate>billing_autotopup_limitcheck_label</label>
            </div>
            <wsb-ui-checkbox
              class="col-sm-1"
              [(checked)]="autotopUpLimitCheck"
              (change)="autotopUpEnableLimitCheck(); autotopupForm.markAsDirty()"
              checkboxId="alertLimitCheck"
            ></wsb-ui-checkbox>
            <div class="col-sm-2" translate>
              <input type="number" class="form-control" id="maxRefillPerPeriod" formControlName="maxRefillPerPeriod" />
            </div>
            <div class="col-sm-5 d-flex" translate>
              <span class="me-2" translate>common_for</span>
              <select id="refillPeriod" formControlName="refillPeriod" class="form-control form-select ">
                <option *ngFor="let period of refillPeriodEnum | keyvalue" [ngValue]="period.key">
                  <span translate>{{ period.value }}</span>
                </option>
              </select>
            </div>
          </div>
          <div class="form-group row">
            <label for="purchaseOrderNumber" class="col-sm-4 align-self-start" translate>billing_autotopup_purchaseordernumber_label</label>
            <div class="col-sm-8" translate>
              <input type="text" class="form-control" id="purchaseOrderNumber" formControlName="purchaseOrderNumber" />
              <small class="form-text text-muted" translate>billing_autotopup_purchaseordernumber_help</small>
            </div>
          </div>
          <div class="form-group row">
            <wsb-ui-checkbox
              [checked]="autotopupForm.get('agreeCheck').value"
              formControlName="agreeCheck"
              checkboxId="agreeCheck"
              class="col-sm-1"
            ></wsb-ui-checkbox>
            <div class="">
              <div>
                <label style="justify-content: flex-start;" for="agreeCheck" translate>billing_autotopup_agreecheck_label</label>
              </div>
              <small class="form-text text-muted" translate>billing_autotopup_agreecheck_help</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
